import { useBook1 } from '@orientaction/hooks_book';
import EbookReaderLayout from './components/EbookReaderLayout';
import Step1Content from './components/Step1Content';
import { useLegacyEbookReader } from './hooks/useLegacyEbookReader';

const EbookDevStep1 = () => {
  const { initValue, getMyValueBook, setId } = useBook1();
  const reader = useLegacyEbookReader({
    getMyValueBook,
    hydrateValue: initValue,
    setId,
  });

  return (
    <EbookReaderLayout {...reader} ebookName="l’Étape 1">
      {(readOnly) => <Step1Content readOnly={readOnly} />}
    </EbookReaderLayout>
  );
};

export default EbookDevStep1;
